import { addDefaultValidators } from 'bundles/crm/imports/helpers';
import type { Country } from '../types';

export const getPropertyFields = (countries: Country[]) => (addDefaultValidators([
  {
    key: 'propertyName',
    type: 'string',
    label: 'Property Name',
    validators: []
  },
  {
    key: 'address',
    type: 'string',
    label: 'Address',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'city',
    type: 'string',
    label: 'City',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'state',
    type: 'string',
    label: 'State (Abbr.)',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'zip',
    type: 'string',
    label: 'Zip/Postal Code',
    validators: [
      {
        validate: 'required'
      }
    ]
  },
  {
    key: 'county',
    type: 'string',
    label: 'County',
    validators: []
  },
  {
    key: 'countryId',
    type: 'select',
    label: 'Country',
    selectOptions: countries.map(country => ({ label: country.name, value: country.code.toString() })),
  },
  {
    key: 'ownerContact',
    type: 'string',
    label: 'Owner Contact',
    validators: []
  },
  {
    key: 'ownerContactId',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner Contact ID',
    validators: []
  },
  {
    key: 'ownerRole',
    type: 'select',
    label: 'Owner Role',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'ownerContact2',
    type: 'string',
    label: 'Owner Contact 2',
    validators: []
  },
  {
    key: 'ownerContactId2',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner Contact ID 2',
    validators: []
  },
  {
    key: 'ownerRole2',
    type: 'select',
    label: 'Owner Contact Role 2',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'ownerContact3',
    type: 'string',
    label: 'Owner Contact 3',
    validators: []
  },
  {
    key: 'ownerContactId3',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner Contact ID 3',
    validators: []
  },
  {
    key: 'ownerRole3',
    type: 'select',
    label: 'Owner Contact Role 3',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'ownerContact4',
    type: 'string',
    label: 'Owner Contact 4',
    validators: []
  },
  {
    key: 'ownerContactId4',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner Contact ID 4',
    validators: []
  },
  {
    key: 'ownerRole4',
    type: 'select',
    label: 'Owner Contact Role 4',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'ownerContact5',
    type: 'string',
    label: 'Owner Contact 5',
    validators: []
  },
  {
    key: 'ownerContactId5',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner Contact ID 5',
    validators: []
  },
  {
    key: 'ownerRole5',
    type: 'select',
    label: 'Owner Contact Role 5',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'ownerContact6',
    type: 'string',
    label: 'Owner Contact 6',
    validators: []
  },
  {
    key: 'ownerContactId6',
    type: [
      'number',
      'integer'
    ],
    label: 'Owner Contact ID 6',
    validators: []
  },
  {
    key: 'ownerRole6',
    type: 'select',
    label: 'Owner Contact Role 6',
    validators: [],
    selectOptions: [
      {
        label: 'Owner / Landlord',
        value: 'owner_landlord'
      },
      {
        label: 'Owner User',
        value: 'owner_user'
      },
      {
        label: 'Owner Contact',
        value: 'owner_representative'
      }
    ]
  },
  {
    key: 'buildingSize',
    type: [
      'number',
      'default'
    ],
    label: 'Building Size',
    validators: []
  },
  {
    key: 'propertySubtypeId',
    type: 'select',
    label: 'Property Type',
    validators: [],
    selectOptions: [
      {
        label: 'Office-Office Building',
        value: '101'
      },
      {
        label: 'Office-Creative/Loft',
        value: '102'
      },
      {
        label: 'Office-Executive Suites',
        value: '103'
      },
      {
        label: 'Office-Medical',
        value: '104'
      },
      {
        label: 'Office-Institutional/Governmental',
        value: '105'
      },
      {
        label: 'Office-Office Warehouse',
        value: '106'
      },
      {
        label: 'Office-Office Condo',
        value: '107'
      },
      {
        label: 'Retail-Street Retail',
        value: '201'
      },
      {
        label: 'Retail-Strip Center',
        value: '202'
      },
      {
        label: 'Retail-Freestanding Building',
        value: '203'
      },
      {
        label: 'Retail-Regional Mall',
        value: '204'
      },
      {
        label: 'Retail-Retail Pad',
        value: '205'
      },
      {
        label: 'Retail-Vehicle Related',
        value: '206'
      },
      {
        label: 'Retail-Outlet Center',
        value: '207'
      },
      {
        label: 'Retail-Power Center',
        value: '208'
      },
      {
        label: 'Retail-Neighborhood Center',
        value: '209'
      },
      {
        label: 'Retail-Community Center',
        value: '210'
      },
      {
        label: 'Retail-Specialty Center',
        value: '211'
      },
      {
        label: 'Retail-Theme/Festival Center',
        value: '212'
      },
      {
        label: 'Retail-Restaurant',
        value: '213'
      },
      {
        label: 'Retail-Post Office',
        value: '214'
      },
      {
        label: 'Retail-Retail Condo',
        value: '215'
      },
      {
        label: 'Industrial-Manufacturing',
        value: '301'
      },
      {
        label: 'Industrial-Warehouse/Distribution',
        value: '302'
      },
      {
        label: 'Industrial-Flex Space',
        value: '303'
      },
      {
        label: 'Industrial-Research & Development',
        value: '304'
      },
      {
        label: 'Industrial-Refrigerated/Cold Storage',
        value: '305'
      },
      {
        label: 'Industrial-Office Showroom',
        value: '306'
      },
      {
        label: 'Industrial-Truck Terminal/Hub/Transit',
        value: '307'
      },
      {
        label: 'Industrial-Self Storage',
        value: '308'
      },
      {
        label: 'Industrial-Industrial Condo',
        value: '309'
      },
      {
        label: 'Land-Office',
        value: '501'
      },
      {
        label: 'Land-Retail',
        value: '502'
      },
      {
        label: 'Land-Retail-Pad',
        value: '503'
      },
      {
        label: 'Land-Industrial',
        value: '504'
      },
      {
        label: 'Land-Residential',
        value: '505'
      },
      {
        label: 'Land-Multifamily',
        value: '506'
      },
      {
        label: 'Land-Other',
        value: '507'
      },
      {
        label: 'Multifamily-High-Rise',
        value: '601'
      },
      {
        label: 'Multifamily-Mid-Rise',
        value: '602'
      },
      {
        label: 'Multifamily-Low-Rise/Garden',
        value: '603'
      },
      {
        label: 'Multifamily-Government Subsidized',
        value: '604'
      },
      {
        label: 'Multifamily-Mobile Home Park',
        value: '605'
      },
      {
        label: 'Multifamily-Senior Living',
        value: '606'
      },
      {
        label: 'Multifamily-Skilled Nursing',
        value: '607'
      },
      {
        label: 'Special Purpose-School',
        value: '701'
      },
      {
        label: 'Special Purpose-Marina',
        value: '702'
      },
      {
        label: 'Special Purpose-Other',
        value: '703'
      },
      {
        label: 'Special Purpose-Golf Course',
        value: '704'
      },
      {
        label: 'Special Purpose-Church',
        value: '705'
      },
      {
        label: 'Hospitality-Full Service',
        value: '801'
      },
      {
        label: 'Hospitality-Limited Service',
        value: '802'
      },
      {
        label: 'Hospitality-Select Service',
        value: '803'
      },
      {
        label: 'Hospitality-Resort',
        value: '804'
      },
      {
        label: 'Hospitality-Economy',
        value: '805'
      },
      {
        label: 'Hospitality-Extended Stay',
        value: '806'
      },
      {
        label: 'Hospitality-Casino',
        value: '807'
      }
    ]
  },
  {
    key: 'lotSize',
    type: [
      'number',
      'default'
    ],
    label: 'Lot Size',
    validators: []
  },
  {
    key: 'lotSizeUnits',
    type: 'select',
    label: 'Lot Size Units',
    validators: [],
    selectOptions: [
      {
        label: 'SF',
        value: 'sf'
      },
      {
        label: 'Acres',
        value: 'acres'
      }
    ]
  },
  {
    key: 'zoning',
    type: 'string',
    label: 'Zoning',
    validators: []
  },
  {
    key: 'yearBuilt',
    type: [
      'number',
      'integer'
    ],
    label: 'Year Built',
    validators: []
  },
  {
    key: 'apn',
    type: 'string',
    label: 'APN',
    validators: []
  },
  {
    key: 'market',
    type: 'string',
    label: 'Market',
    validators: []
  },
  {
    key: 'submarket',
    type: 'string',
    label: 'Submarket',
    validators: []
  },
  {
    key: 'micromarket',
    type: 'string',
    label: 'Micromarket',
    validators: []
  },
  {
    key: 'crossStreets',
    type: 'string',
    label: 'Cross Streets',
    validators: []
  },
  {
    key: 'latitude',
    type: 'string',
    label: 'Latitude',
    validators: []
  },
  {
    key: 'longitude',
    type: 'string',
    label: 'Longitude',
    validators: []
  },
  {
    key: 'power',
    type: 'checkbox',
    label: 'Power',
    validators: []
  },
  {
    key: 'cornerProperty',
    type: 'checkbox',
    label: 'Corner Property',
    validators: []
  },
  {
    key: 'vacancy_percent',
    type: [
      'number',
      'percent'
    ],
    label: 'Vacancy %',
    validators: []
  },
  {
    key: 'gas',
    type: 'checkbox',
    label: 'Gas',
    validators: []
  },
  {
    key: 'freeStanding',
    type: 'checkbox',
    label: 'Freestanding',
    validators: []
  },
  {
    key: 'cable',
    type: 'checkbox',
    label: 'Cable',
    validators: []
  },
  {
    key: 'sewer',
    type: 'checkbox',
    label: 'Sewer',
    validators: []
  },
  {
    key: 'freightElevator',
    type: 'checkbox',
    label: 'Freight Elevator',
    validators: []
  },
  {
    key: 'centralHvac',
    type: 'checkbox',
    label: 'Central HVAC',
    validators: []
  },
  {
    key: 'telephone',
    type: 'checkbox',
    label: 'Telephone',
    validators: []
  },
  {
    key: 'waterfront',
    type: 'checkbox',
    label: 'Waterfront',
    validators: []
  },
  {
    key: 'railAccess',
    type: 'checkbox',
    label: 'Rail Access',
    validators: []
  },
  {
    key: 'sprinklers',
    type: 'checkbox',
    label: 'Sprinklers',
    validators: []
  },
  {
    key: 'handicapAccess',
    type: 'checkbox',
    label: 'Handicap Access',
    validators: []
  },
  {
    key: 'water',
    type: 'checkbox',
    label: 'Water',
    validators: []
  },
  {
    key: 'securityGuard',
    type: 'checkbox',
    label: 'Security Guard',
    validators: []
  },
  {
    key: 'leedCertified',
    type: 'checkbox',
    label: 'LEED Certified',
    validators: []
  },
  {
    key: 'irrigation',
    type: 'checkbox',
    label: 'Irrigation',
    validators: []
  },
  {
    key: 'irrigationDescription',
    type: 'string',
    label: 'Irrigation Description',
    validators: [{ validate: 'length', max: 16384 }],
  },
  {
    key: 'trailerParking',
    type: 'checkbox',
    label: 'Trailer Parking',
    validators: []
  },
  {
    key: 'centrixEquipped',
    type: 'checkbox',
    label: 'Centrix Equipped',
    validators: []
  },
  {
    key: 'availableSf',
    type: [
      'number',
      'default'
    ],
    label: 'Available SF',
    validators: []
  },
  {
    key: 'buildingClass',
    type: 'select',
    label: 'Building Class',
    validators: [],
    selectOptions: [
      {
        label: 'A',
        value: 'A'
      },
      {
        label: 'B',
        value: 'B'
      },
      {
        label: 'C',
        value: 'C'
      }
    ]
  },
  {
    key: 'numberOfUnits',
    type: [
      'number',
      'default'
    ],
    label: 'Number of Units',
    validators: []
  },
  {
    key: 'occupancyPercent',
    type: [
      'number',
      'percent'
    ],
    label: 'Occupancy Percent',
    validators: []
  },
  {
    key: 'numberOfParkingSpaces',
    type: [
      'number',
      'default'
    ],
    label: 'Number of Parking Spaces',
    validators: []
  },
  {
    key: 'renovated',
    type: [
      'number',
      'default'
    ],
    label: 'Renovated',
    validators: []
  },
  {
    key: 'constructionStatusId',
    type: 'select',
    label: 'Construction Status',
    validators: [],
    selectOptions: [
      {
        label: 'Existing',
        value: '1'
      },
      {
        label: 'Under Construction',
        value: '2'
      },
      {
        label: 'Proposed',
        value: '3'
      },
      {
        label: 'Build to Suit',
        value: '4'
      }
    ]
  },
  {
    key: 'frontage',
    type: [
      'number',
      'default'
    ],
    label: 'Frontage',
    validators: []
  },
  {
    key: 'lotDepth',
    type: [
      'number',
      'default'
    ],
    label: 'Lot Depth',
    validators: []
  },
  {
    key: 'ceilingHeight',
    type: [
      'number',
      'default'
    ],
    label: 'Ceiling Height',
    validators: []
  },
  {
    key: 'ceilingHeightMin',
    type: [
      'number',
      'default'
    ],
    label: 'Ceiling Height Min',
    validators: []
  },
  {
    key: 'parkingRatio',
    type: [
      'number',
      'default'
    ],
    label: 'Parking Ratio',
    validators: []
  },
  {
    key: 'parkingType',
    type: 'select',
    label: 'Parking Type',
    validators: [],
    selectOptions: [
      {
        label: 'Roof-Top',
        value: 'Roof-Top'
      },
      {
        label: 'Structure',
        value: 'Structure'
      },
      {
        label: 'Surface',
        value: 'Surface'
      },
      {
        label: 'Underground',
        value: 'Underground'
      },
      {
        label: 'Other',
        value: 'Other'
      }
    ]
  },
  {
    key: 'typicalFloorSize',
    type: [
      'number',
      'default'
    ],
    label: 'Typical Floor Size',
    validators: []
  },
  {
    key: 'industrialOfficeSpace',
    type: [
      'number',
      'default'
    ],
    label: 'Industrial Office Space',
    validators: []
  },
  {
    key: 'grossBuildingArea',
    type: [
      'number',
      'default'
    ],
    label: 'Gross Building Area',
    validators: []
  },
  {
    key: 'numberOfBuildings',
    type: [
      'number',
      'default'
    ],
    label: 'Number of Buildings',
    validators: []
  },
  {
    key: 'gradeLevelDoors',
    type: [
      'number',
      'integer'
    ],
    label: 'Grade Level Doors',
    validators: []
  },
  {
    key: 'dockHighDoors',
    type: [
      'number',
      'integer'
    ],
    label: 'Dock High Doors',
    validators: []
  },
  {
    key: 'trafficCount',
    type: [
      'number',
      'default'
    ],
    label: 'Traffic Count',
    validators: []
  },
  {
    key: 'trafficCountStreet',
    type: 'string',
    label: 'Traffic Count Street',
    validators: []
  },
  {
    key: 'numberOfLots',
    type: [
      'number',
      'default'
    ],
    label: 'Number of Lots',
    validators: []
  },
  {
    key: 'roof',
    type: 'string',
    label: 'Roof',
    validators: [{ validate: 'length', max: 200 }],
  },
  {
    key: 'condition',
    type: 'select',
    label: 'Condition',
    validators: [],
    selectOptions: [
      {
        label: 'Excellent',
        value: 'Excellent'
      },
      {
        label: 'Good',
        value: 'Good'
      },
      {
        label: 'Average',
        value: 'Average'
      },
      {
        label: 'Fair',
        value: 'Fair'
      },
      {
        label: 'Poor',
        value: 'Poor'
      }
    ]
  },
  {
    key: 'bestUse',
    type: 'string',
    label: 'Best Use',
    validators: []
  },
  {
    key: 'powerDescription',
    type: 'string',
    label: 'Power Description',
    validators: [{ validate: 'length', max: 200 }],
  },
  {
    key: 'township',
    type: 'string',
    label: 'Township',
    validators: []
  },
  {
    key: 'numberOfElevators',
    type: [
      'number',
      'default'
    ],
    label: 'Number of Elevators',
    validators: []
  },
  {
    key: 'elevators',
    type: 'string',
    label: 'Elevators',
    validators: []
  },
  {
    key: 'framing',
    type: 'string',
    label: 'Framing',
    validators: [{ validate: 'length', max: 200 }],
  },
  {
    key: 'constructionDescription',
    type: 'string',
    label: 'Construction Description',
    validators: [{ validate: 'length', max: 16384 }],
  },
  {
    key: 'topography',
    type: 'string',
    label: 'Topography',
    validators: [{ validate: 'length', max: 200 }],
  },
  {
    key: 'driveInBays',
    type: [
      'number',
      'integer'
    ],
    label: 'Drive In Bays',
    validators: []
  },
  {
    key: 'amenities',
    type: 'string',
    label: 'Amenities',
    validators: [{ validate: 'length', max: 16384 }],
  },
  {
    key: 'interiorDescription',
    type: 'string',
    label: 'Interior Description',
    validators: [{ validate: 'length', max: 16384 }],
  },
  {
    key: 'exteriorDescription',
    type: 'string',
    label: 'Exterior Description',
    validators: [{ validate: 'length', max: 16384 }],
  },
  {
    key: 'utilitiesDescription',
    type: 'string',
    label: 'Utilities Description',
    validators: [{ validate: 'length', max: 16384 }],
  },
  {
    key: 'restrooms',
    type: 'string',
    label: 'Restrooms',
    validators: [{ validate: 'length', max: 200 }],
  },
  {
    key: 'hvac',
    type: 'string',
    label: 'HVAC',
    validators: [{ validate: 'length', max: 200 }],
  },
  {
    key: 'sprinklerDescription',
    type: 'string',
    label: 'Sprinkler Description',
    validators: []
  }
]));
